import React from 'react';
import { Cable } from 'lucide-react';
import { ServicoChip, HpChip } from './servicos';

const fmtDataHora = (iso) => (iso ? new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-');

// Card no Detalhar da venda com a viabilidade consultada na Nova Venda
export const ViabilidadeVendaResumo = ({ viabilidade }) => {
  if (!viabilidade?.hp) return null;
  const v = viabilidade;
  const tem = (v.vendaveis || []).length > 0;
  return (
    <div className={`rounded-lg border px-3 py-2 space-y-1.5 ${tem ? 'border-purple-300 dark:border-purple-800 bg-purple-50 dark:bg-purple-900/20' : 'border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-900/20'}`} data-testid="viabilidade-venda-resumo">
      <div className="flex flex-wrap items-center gap-2">
        <Cable className={`w-4 h-4 ${tem ? 'text-purple-600' : 'text-red-600'}`} />
        <p className="text-sm font-semibold" data-testid="viabilidade-venda-titulo">Viabilidade Claro: {tem ? `${v.vendaveis.length} produto(s) vendável(is)` : 'sem produto vendável'}</p>
        <HpChip hp={v.hp} testid="viabilidade-venda-hp" />
      </div>
      <p className="text-xs text-gray-600 dark:text-gray-300">{v.logradouro}, {v.numero}{v.complementos ? ` — ${v.complementos}` : ''} • {v.bairro}{v.cidade ? ` • ${v.cidade}/${v.uf}` : ''} • CEP {v.cep}</p>
      <div className="flex flex-wrap gap-1">{(v.servicos || []).map((s) => <ServicoChip key={s.tipo} s={s} />)}</div>
      <p className="text-[11px] text-gray-500">Consultado em {fmtDataHora(v.consultado_em)}{v.consultado_por ? ` por ${v.consultado_por}` : ''}{v.codificacao ? ` • ${v.codificacao}` : ''}</p>
    </div>
  );
};
